import React from 'react';
import styled from 'styled-components';
import { Button } from '@mui/material';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import LockPersonIcon from '@mui/icons-material/LockPerson';
import { panelTheme } from '../../PanelComerciales.theme';

export type QuickActionId = 'create-team' | 'block-commercial';

interface QuickActionsProps {
    onAction: (action: QuickActionId) => void;
}

const QuickActionsRoot = styled.section`
    display: flex;
    flex-direction: column;
    gap: 12px;

    h2 {
        font-size: 16px;
        font-weight: 600;
        margin: 0;
        color: ${panelTheme.colors.text};
    }

    .grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 12px;
    }

    button {
        height: 80px;
        flex-direction: column;
        text-transform: none;
        font-weight: 500;
        border-radius: ${panelTheme.radius.md};
        border: 1px solid ${panelTheme.colors.border};
        background: ${panelTheme.colors.surface};
        color: ${panelTheme.colors.text};
        gap: 8px;
        padding: 14px;
        box-shadow: ${panelTheme.shadow.sm};

        &:hover {
            background: ${panelTheme.colors.surfaceMuted};
            border-color: ${panelTheme.colors.indigo};
            color: ${panelTheme.colors.indigo};
        }
    }

    .icon {
        color: ${panelTheme.colors.violet};
    }
`;

const QuickActions: React.FC<QuickActionsProps> = ({ onAction }) => (
    <QuickActionsRoot>
        <h2>Controles rápidos</h2>
        <div className='grid'>
            <Button onClick={() => onAction('create-team')}>
                <GroupAddIcon className='icon' />
                <span>Crear nuevo equipo</span>
            </Button>
            <Button onClick={() => onAction('block-commercial')}>
                <LockPersonIcon className='icon' />
                <span>Desactivar / Bloquear comercial</span>
            </Button>
        </div>
    </QuickActionsRoot>
);

export default QuickActions;
